import { v4 as uuidv4 } from 'uuid';

import { InitState } from './state';
import { InitAction, InitActions, SetInitial, SetLiffReady, InitSetCountries, SetCustomerStatus } from './action';
import { parseStringToInt } from '../../converter/stringConverter';
import { CustomerStatus, convertIntToCustomerStatus } from '../../models/customer/status';

export const initInitial: InitState = {
    translations: {},
    countries: [],
    ready: false,
    liffReady: false,
    language: 'th',
    userId: 'unknown',
    name: 'unknown',
    landingId: uuidv4(),
    userStatus: CustomerStatus.NO_APPROVAL,
    lineLiffId: 'DEFAULT'
};

export function initReducer(state: InitState = initInitial, action: InitActions) {
    switch (action.type) {
        case InitAction.SetInitial:
            const setInitialAction = action as SetInitial;
            const inputValue = setInitialAction.value.translations;
            const translations: {[key:number]: string} = {};
            const keys = Object.keys(setInitialAction.value.translations);

            keys.map((key) => {
                translations[parseStringToInt(key)] = inputValue[key];
                return key;
            });

            return {
                ...state,
                ready: true,
                translations,
                userStatus: convertIntToCustomerStatus(setInitialAction.value.userStatus),
            };
        case InitAction.SetLiffReady: // ***
            const setLiffReadyAction = action as SetLiffReady;

            return {
                ...state,
                userId: setLiffReadyAction.value.userId || initInitial.userId,
                name: setLiffReadyAction.value.name || initInitial.name,
                lineLiffId: setLiffReadyAction.value.lineLiffId || initInitial.lineLiffId,
                liffReady: true,
            };
        case InitAction.SetCountries:
            const setCountriesAction = action as InitSetCountries;

            return {
                ...state,
                countries: setCountriesAction.value.countries,
            };
        case InitAction.SetCustomerStatus:
            const setCustomerStatusAction = action as SetCustomerStatus;

            return {
                ...state,
                userStatus: setCustomerStatusAction.value.customerStatus,
            };
      default:
        return state;
    }
}